type RuntimeEnv = {
  PUBLIC_API_BASE_URL?: string;
  MYZAKAZ_WEB_URL?: string;
  X_AUTH_API_KEY?: string;
  TELEGRAM_API_ID?: string;
  TELEGRAM_API_HASH?: string;
};

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    __MYZAKAZ_ENV__?: RuntimeEnv;
  }
}

const runtime = (typeof window !== 'undefined' && window.__MYZAKAZ_ENV__) || {};

export const API_BASE_URL = runtime.PUBLIC_API_BASE_URL
  || process.env.PUBLIC_API_BASE_URL
  || process.env.ZAKAZPRO_API_URL
  || 'https://api.myzakaz.org';

export const WEB_BASE_URL = runtime.MYZAKAZ_WEB_URL
  || process.env.MYZAKAZ_WEB_URL
  || process.env.ZAKAZPRO_WEB_URL
  || 'https://t.myzakaz.org';

export const X_AUTH_API_KEY = runtime.X_AUTH_API_KEY
  || process.env.X_AUTH_API_KEY
  || '';

export const TELEGRAM_API_ID = runtime.TELEGRAM_API_ID
  || process.env.TELEGRAM_API_ID
  || '';

export const TELEGRAM_API_HASH = runtime.TELEGRAM_API_HASH
  || process.env.TELEGRAM_API_HASH
  || '';

export const SELLER_API_BASE = `${API_BASE_URL}/v1/seller`;
